import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Classifications } from 'components/Classifications';

export const ClassificationsPage: FC = () => {
	return (
		<Page title="Classifications – MPM Service">
			<Classifications />
		</Page>
	);
};
